import * as React from "react";
import AutoSizer from "react-virtualized-auto-sizer";
export const withSize = (props) => {
    return (OriginalComponent) => {
        return class WithSize extends React.Component {
            render() {
                return (React.createElement(AutoSizer, Object.assign({}, props), ({ height, width }) => {
                    return React.createElement(OriginalComponent, Object.assign({}, this.props, { height: height, width: width }));
                }));
            }
        };
    };
};
//# sourceMappingURL=withSize.js.map